(function(window, document, $) {
  'use strict';

  if (!$) {
    return;
  }

  function productHtml(product) {
    return '<div>' +
      '<div class="row">' +
        '<div class="col-sm-4">' +
          '<a href="' + product.url + '" title="' + product.alt + '">' +
            '<img src="' + product.image + '" alt="' + product.alt + '" />' +
          '</a>' +
        '</div>' +
        '<div class="col-sm-8">' +
          '<div class="product">' +
            '<h3>' + product.heading + '</h3>' +
            '<h5><a href="' + product.url + '" title="' + product.alt + '"><span data-notify-html="title"/></a></h5>' +
            '<div class="product-price">' + product.priceHtml + '</div>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function initNotifySlider() {
    $('[data-notify-product-slider]').each(function(sliderIndex) {
      var $slider = $(this);
      var notifications = [];
      var delay = parseInt($slider.attr('data-delay'), 10) || 6000;
      var autoHideDelay = parseInt($slider.attr('data-auto-hide-delay'), 10) || 3000;

      if (!$.notify || !$.notify.addStyle) {
        return;
      }

      $slider.find('[data-notify-product]').each(function(productIndex) {
        var $product = $(this);
        var styleName = 'notifStyle' + sliderIndex + '-' + productIndex;

        $.notify.addStyle(styleName, {
          html: productHtml({
            url: $product.attr('data-url') || '#',
            alt: $product.attr('data-alt') || '',
            image: $product.attr('data-image') || '',
            heading: $product.attr('data-heading') || '',
            priceHtml: $product.attr('data-price-html') || ''
          }),
          classes: {
            base: {
              opacity: '1',
              width: '320px',
              background: '#fff',
              padding: '0'
            }
          }
        });

        notifications.push({
          sStyle: styleName,
          title: $product.attr('data-title') || '',
          button: 'Check it now!'
        });
      });

      if (!notifications.length) {
        return;
      }

      setInterval(function() {
        var randChoose = notifications[Math.round(Math.random() * (notifications.length - 1))];

        $.notify({
          title: randChoose.title,
          button: randChoose.button
        }, {
          style: randChoose.sStyle,
          autoHide: true,
          autoHideDelay: autoHideDelay,
          clickToHide: false,
          globalPosition: 'bottom left',
          hideAnimation: 'fadeOut',
          showAnimation: 'fadeIn',
          showDuration: 1000,
          hideDuration: 1000
        });
      }, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNotifySlider);
  } else {
    initNotifySlider();
  }
}(window, document, window.jQuery));
